<template>
    <label
        class="form-switch"
        :class="[
            additionalClass,
            {
                'form-switch_disabled': disabled,
                'form-switch_sm': smallSize,
                'form-switch_red': isRed,
                'form-switch_green': isGreen,
                'form-switch_nagetive_red': isNegativeRed
            }
        ]"
    >
        <input type="checkbox" name="" :true-value="1" :false-value="0" v-model="model" :value="val" :id="id" />
        <div
            class="form-switch__custom-elem"
            :class="{
                'form-switch__custom-elem_sm': smallSize,
                'form-switch__custom-elem_red': isRed,
                'form-switch__custom-elem_green': isGreen,
                'form-switch__custom-elem_new-green': isNewGreen,
                'form-switch__custom-elem_nagetive_red': isNegativeRed
            }"
        ></div>
    </label>
</template>

<script>
export default {
    name: "FormSwitcher",
    props: {
        val: [Boolean, Number],
        additionalClass: String,
        disabled: {
            type: Boolean,
            default: false
        },
        id: String,
        smallSize: {
            type: Boolean,
            default: false
        },
        booleanMode: {
            type: Boolean,
            default: false
        },
        isRed: {
            type: [Boolean, Number],
            default: false
        },
        isGreen: {
            type: [Boolean, Number],
            default: false
        },
        isNewGreen: {
            type: [Boolean, Number],
            default: false
        },
        isNegativeRed: {
            type: [Boolean, Number],
            default: false
        }
    },
    computed: {
        model: {
            get() {
                return this.booleanMode ? Boolean(this.val) : this.val ? 1 : 0
            },
            set(val) {
                this.$emit("input", val)
            }
        }
    }
}
</script>
